import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_DRIVERS_LIST = "GET_DRIVERS_LIST";
export const CREATE_DRIVER = "CREATE_DRIVER";
export const DELETE_DRIVER = "DELETE_DRIVER"
export const DRIVER_ACTIVE = "DRIVER_ACTIVE";
export const DRIVER_DEACTIVE = "DRIVER_DEACTIVE";
export const DRIVER_PROFILE = "DRIVER_PROFILE";
export const UPDATE_DRIVER = "UPDATE_DRIVER";
export const GET_TRANSPORTATION_ALLOWANCE_LIST =
  "GET_TRANSPORTATION_ALLOWANCE_LIST";
export const GET_OTHER_PHOTOS_LIST = "GET_OTHER_PHOTOS_LIST";
export const GET_DRIVER_LEAVES_LIST = "GET_DRIVER_LEAVES_LIST";

export const getDriversList = (page, rowsPerPage, data) => (dispatch) => { // get driver list api call
  axios.post(`/drivers?page=${page}&size=${rowsPerPage}`, data).then((res) => {
    dispatch({
      type: GET_DRIVERS_LIST,
      payload: res.data,
    });
  });
};

export const createDriver = (data) => (dispatch) => { // create driver api call
  axios
    .post("/driver/create", data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: CREATE_DRIVER,
        payload: response.data,
      });
      setTimeout(() => dispatch(getDriversList(1, 10)), 1500);
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const deleteDriver = (id) => (dispatch) => { // delete driver api call
  axios.delete(`/drivers/${id}/delete`).then((res) => {
    dispatch({
      type: DELETE_DRIVER,
      payload: res.data,
    });
    dispatch(getDriversList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', 'success'));
  }).
    catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const driverActive = (id) => (dispatch) => { // driver activate api call
  axios.patch(`/drivers/${id}/activate`).then((res) => {
    dispatch({
      type: DRIVER_ACTIVE,
      payload: res.data,
    });
    dispatch(getDriversList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  });
};

export const driverDeactive = (id) => (dispatch) => { // driver deactive api call
  axios.patch(`/drivers/${id}/deactivate`).then((res) => {
    dispatch({
      type: DRIVER_DEACTIVE,
      payload: res.data,
    });
    dispatch(getDriversList(1, 10));
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  });
};

export const driverProfile = (id) => (dispatch) => { // driver profile get api call
  axios.get(`/driver/${id}`).then((res) => {
    dispatch({
      type: DRIVER_PROFILE,
      payload: res.data,
    });
  });
};

export const updateDriver = (id, data) => (dispatch) => { // update driver api call
  axios
    .post(`/driver/${id}/update`, data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: UPDATE_DRIVER,
        payload: response.data,
      });
      setTimeout(() => dispatch(getDriversList(1, 10)), 1500);
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getTransportationAllowanceList = (id, data) => (dispatch) => { // get transportation allowance list of driver profile api call
  axios
    .post(
      `/driver/${id}/transportation`,
      data
    )
    .then((response) => {
      dispatch({
        type: GET_TRANSPORTATION_ALLOWANCE_LIST,
        payload: response.data,
      });
    })
};

export const getOtherPhotosList = (id) => (dispatch) => { // get other photos api call for driver profile
  axios
    .post(`/driver/${id}/otherphoto/get`)
    .then((res) => {
      dispatch({
        type: GET_OTHER_PHOTOS_LIST,
        payload: res.data,
      });
    });
};

export const getDriverLeavesList = (id, page, rowsPerPage, data) => (dispatch) => { // get driver leaves list for driver profile api call
  axios
    .post(`/driver/${id}/leave/get?page=${page}&size=${rowsPerPage}`, data)
    .then((res) => {
      dispatch({
        type: GET_DRIVER_LEAVES_LIST,
        payload: res.data,
      });
    });
};
